<template>
  <div>
  <b-navbar toggleable="lg" type="dark">
    <b-navbar-brand href="#"> <img width="30" style="border-radius:50%;" src="img/logo" alt=""> </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item @click="attendance=false" activeClass="active" to="/" exact>Inicio</b-nav-item>        
        <b-nav-item @click="attendance=false" activeClass="active" to="/students">Estudiantes</b-nav-item>        
        <b-nav-item @click="attendance=false" activeClass="active" to="/parents">Padres</b-nav-item>        
        <b-nav-item @click="attendance=false" activeClass="active" to="/groups">Grupos</b-nav-item>        
        <!-- <b-nav-item activeClass="active" to="/attendance">Asistencia</b-nav-item>         -->

        <b-nav-item-dropdown right :class="[attendance ? 'active':'']">
          <template v-slot:button-content >
            <em>Asistencia</em>
          </template>          
          <b-dropdown-item to="/attendance" activeClass="active" exact @click="attendance=true">Toma de Asistencia</b-dropdown-item>
          <b-dropdown-item to="/attendance/report" activeClass="active" exact @click="attendance=true">Reporte de Asistencia</b-dropdown-item>
          <b-dropdown-item to="/attendance/absents" activeClass="active" exact @click="attendance=true">Reporte de Ausentes</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          
          <template v-slot:button-content>
            <em>Usuario</em>
          </template>          
          <b-dropdown-item href="#" @click="logout()">Cerrar Sesión</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</template>

<script>
export default {
  data(){
    return {
      attendance:false
    }
  },
  methods:{
    async logout(){
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="css" scoped>
  .active{border-color: #fff !important}
</style>